import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listKeywordFilter',
  pure: true
})
export class ListKeywordFilterPipe implements PipeTransform{
  transform(value: any[], keyword: string, changeDetectionFlag?: any): any[] {
    return value.filter((element: any) => element?.label.toLowerCase().includes(keyword.toLowerCase()));
  }
}

